import React from "react";
import PatientContactSection from "../../careprovider/visits/visitdetails/components/patientdetailscomponent/PatientContactSection";

const VolunteerStatistics = ({ fields, statistics, selectedYear, setSelectedYear, joiningDate }) => {
  return (
    <div className="px-3 pb-3">
      <PatientContactSection contact={statistics} fields={fields} selectedYear={selectedYear} setSelectedYear={setSelectedYear} joiningDate={joiningDate} />
    </div>
  );
};

export default VolunteerStatistics;
